import React from "react";
import "./sectionThree.css";
import sectionTwoSideImage from "../../../assets/sectionThreeSideImage.gif";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import links from "../../../links/allLinks";

const CustomButton = ({ icon: Icon, label, buttonLink }) => (
  <button
    className="custom-button-section-three"
    onClick={() => {
      window.open(buttonLink);
    }}
  >
    <Icon className="icon-section-three" />
    {label}
  </button>
);

const SectionThree = () => {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <div className="sectionThree">
      {/* <SectionSpacer /> */}
      <div className="sectionThreeContainer">
        {/* Text Section */}
        <div className="text-section">
          <div className="dm-automation">
            <p>Don't Miss Out!</p>
          </div>
          <div className="caption-text">
            <span>Keep Yourself Updated 🎯</span>
            <span>Join Us on WhatsApp & Instagram</span>
          </div>
          <div className="button-container">
            <CustomButton
              icon={FaWhatsapp}
              label="WhatsApp"
              buttonLink={links
                .filter((item) =>
                  isMobile
                    ? item.rawgrWhatsAppGroupLink
                    : item.rawgrWhatsAppWebGroupLink
                )
                .map((item) =>
                  isMobile
                    ? item.rawgrWhatsAppGroupLink
                    : item.rawgrWhatsAppWebGroupLink
                )}
            />
            <CustomButton
              icon={FaInstagram}
              label="Instagram"
              buttonLink={links
                .filter((item) => item?.rawgrInstagramLink)
                .map((item) => item.rawgrInstagramLink)}
            />
          </div>
        </div>

        <div className="image-section">
          <img src={sectionTwoSideImage} alt="Stay Updated" />
        </div>
      </div>
    </div>
  );
};

export default SectionThree;
